import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import MarketingLayout from "../layouts/MarketingLayout";
import HomePage from "../pages/home/HomePage";
import NewUserGiftPage from "../pages/activity/NewUserGiftPage";
import NewUserDownloadPage from "../pages/activity/NewUserDownloadPage";
import ScoreQueryPage from "../pages/score-query/ScoreQueryPage";
import VolunteerPlanningPage from "../pages/volunteer-planning/VolunteerPlanningPage";

const standaloneRoutePrefixes = ["/volunteer-planning", "/score-query", "/activity"];

function AppRouter() {
  const location = useLocation();
  const isStandalone = standaloneRoutePrefixes.some((prefix) =>
    location.pathname.startsWith(prefix),
  );

  if (isStandalone) {
    return (
      <Routes>
        <Route path="/volunteer-planning" element={<VolunteerPlanningPage />} />
        <Route path="/score-query" element={<ScoreQueryPage />} />

        {/* 活动页：每种活动类型对应一个路由 */}
        <Route path="/activity/new-user-gift" element={<NewUserGiftPage />} />
        <Route path="/activity/new-user-download" element={<NewUserDownloadPage />} />

        {/* 向后兼容：/activity 重定向到新用户存储空间礼包页 */}
        <Route path="/activity" element={<Navigate to="/activity/new-user-gift" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MarketingLayout>
            <HomePage />
          </MarketingLayout>
        }
      />
    </Routes>
  );
}

export default AppRouter;
